// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 48px;
  cursor: default;
  line-height: normal;
}
.main-button.with-icon {
  padding: 10.5px 12px 10.5px 8px;
}
.main-button:not(:disabled) {
  cursor: pointer;
}
.main-button.primary {
  color: var(--white-color);
  background: var(--accent-color);
}
.main-button.primary:not(:disabled):hover {
  background: var(--accent-color-hover);
}
.main-button.primary:not(:disabled):not(.selected):active, .main-button.primary:not(:disabled):not(.selected).active {
  background: var(--accent-color-pressed);
}
.main-button.primary .main-button__icon-wrapper svg path {
  fill: var(--white-color);
}
.main-button.secondary {
  color: var(--white-color);
  background: transparent;
  border: 3px solid var(--accent-color);
}
.main-button.secondary:not(:disabled):not(.selected):hover {
  background: var(--accent-color);
}
.main-button.secondary:not(:disabled):not(.selected):active {
  background: var(--accent-color-pressed);
  border: 3px solid var(--accent-color-pressed);
}
.main-button.third-style {
  color: var(--accent-color);
  background: transparent;
  border: 3px solid var(--accent-color);
}
.main-button.third-style:not(:disabled):not(.selected):hover {
  color: var(--white-color);
  background: var(--accent-color);
  border-color: var(--accent-color);
}
.main-button.third-style:not(:disabled):not(.selected):hover .main-button__icon-wrapper svg path {
  fill: var(--white-color);
}
.main-button.third-style:not(:disabled):not(.selected):active {
  color: var(--white-color);
  background: var(--accent-color-pressed);
  border-color: var(--accent-color-pressed);
}
.main-button.third-style:not(:disabled):not(.selected):active .main-button__icon-wrapper svg path {
  fill: var(--white-color);
}
.main-button.third-style .main-button__icon-wrapper svg path {
  fill: var(--accent-color);
}
.main-button.fourth-style {
  color: var(--white-color);
  background: transparent;
  border: 3px solid var(--white-color);
}
.main-button.fourth-style:not(:disabled):hover {
  color: var(--accent-color);
  border-color: var(--accent-color);
  /*& .main-button__icon-wrapper {
    & svg path {
      fill: var(--accent-color-hover);
    }
  }*/
}
.main-button.fourth-style:not(:disabled):active {
  color: var(--accent-color-pressed);
  border-color: var(--accent-color-pressed);
  /*& .main-button__icon-wrapper {
    & svg path {
      fill: var(--accent-color-pressed);
    }
  }*/
}
.main-button.fourth-style .main-button__icon-wrapper svg path {
  fill: var(--white-color);
}

@media only screen and (min-device-width: 320px) {
  .main-button {
    min-width: 164px;
    padding: 12px 20px;
    font-size: 14px;
    letter-spacing: 0.7px;
  }
  .main-button.secondary {
    padding: 9px 31.5px;
  }
}
@media only screen and (min-device-width: 768px) {
  .main-button {
    min-width: 220px;
    padding: 12px 24px;
    font-size: 18px;
    letter-spacing: 0.9px;
  }
  .main-button.secondary {
    padding: 9px 33px;
  }
}
@media only screen and (min-device-width: 992px) {
  .main-button {
    min-width: 220px;
    padding: 16px 36px;
    font-size: 18px;
    letter-spacing: 0.9px;
  }
  .main-button.secondary {
    padding: 9px 33px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .main-button {
    min-width: 220px;
    padding: 20px 44px;
    font-size: 20px;
    letter-spacing: 1px;
  }
  .main-button.secondary {
    padding: 9px 31.5px;
  }
}
.main-button__icon-wrapper {
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-family: Inter, serif;
  font-weight: 800;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/button.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AACF;AACE;EACE,+BAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,yBAAA;EACA,+BAAA;AADJ;AAGI;EACE,qCAAA;AADN;AAII;EAEE,uCAAA;AAHN;AAOM;EACE,wBAAA;AALR;AAUE;EACE,yBAAA;EACA,uBAAA;EACA,qCAAA;AARJ;AAUI;EACE,+BAAA;AARN;AAWI;EACE,uCAAA;EACA,6CAAA;AATN;AAaE;EACE,0BAAA;EACA,uBAAA;EACA,qCAAA;AAXJ;AAaI;EACE,yBAAA;EACA,+BAAA;EACA,iCAAA;AAXN;AAcQ;EACE,wBAAA;AAZV;AAiBI;EACE,yBAAA;EACA,uCAAA;EACA,yCAAA;AAfN;AAkBQ;EACE,wBAAA;AAhBV;AAsBM;EACE,yBAAA;AApBR;AAyBE;EACE,yBAAA;EACA,uBAAA;EACA,oCAAA;AAvBJ;AAyBI;EACE,0BAAA;EACA,iCAAA;EAEA;;;;IAAA;AApBN;AA2BI;EACE,kCAAA;EACA,yCAAA;EAEA;;;;IAAA;AAtBN;AA+BM;EACE,wBAAA;AA7BR;;AAmCA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;EAhCF;EAkCA;IACE,mBAAA;EAhCF;AACF;AAmCA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;EAjCF;EAmCA;IACE,iBAAA;EAjCF;AACF;AAoCA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;EAlCF;EAoCA;IACE,iBAAA;EAlCF;AACF;AAqCA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAnCF;EAqCA;IACE,mBAAA;EAnCF;AACF;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AApCF","sourcesContent":[".main-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 48px;\n  cursor: default;\n  line-height: normal;\n\n  &.with-icon {\n    padding: 10.5px 12px 10.5px 8px;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &.primary {\n    color: var(--white-color);\n    background: var(--accent-color);\n\n    &:not(:disabled):hover {\n      background: var(--accent-color-hover);\n    }\n\n    &:not(:disabled):not(.selected):active,\n    &:not(:disabled):not(.selected).active {\n      background: var(--accent-color-pressed);\n    }\n\n    & .main-button__icon-wrapper {\n      & svg path {\n        fill: var(--white-color);\n      }\n    }\n  }\n\n  &.secondary {\n    color: var(--white-color);\n    background: transparent;\n    border: 3px solid var(--accent-color);\n\n    &:not(:disabled):not(.selected):hover {\n      background: var(--accent-color);\n    }\n\n    &:not(:disabled):not(.selected):active {\n      background: var(--accent-color-pressed);\n      border: 3px solid var(--accent-color-pressed);\n    }\n  }\n\n  &.third-style {\n    color: var(--accent-color);\n    background: transparent;\n    border: 3px solid var(--accent-color);\n\n    &:not(:disabled):not(.selected):hover {\n      color: var(--white-color);\n      background: var(--accent-color);\n      border-color: var(--accent-color);\n\n      & .main-button__icon-wrapper {\n        & svg path {\n          fill: var(--white-color);\n        }\n      }\n    }\n\n    &:not(:disabled):not(.selected):active {\n      color: var(--white-color);\n      background: var(--accent-color-pressed);\n      border-color: var(--accent-color-pressed);\n\n      & .main-button__icon-wrapper {\n        & svg path {\n          fill: var(--white-color);\n        }\n      }\n    }\n\n    & .main-button__icon-wrapper {\n      & svg path {\n        fill: var(--accent-color);\n      }\n    }\n  }\n\n  &.fourth-style {\n    color: var(--white-color);\n    background: transparent;\n    border: 3px solid var(--white-color);\n\n    &:not(:disabled):hover {\n      color: var(--accent-color);\n      border-color: var(--accent-color);\n\n      /*& .main-button__icon-wrapper {\n        & svg path {\n          fill: var(--accent-color-hover);\n        }\n      }*/\n    }\n\n    &:not(:disabled):active {\n      color: var(--accent-color-pressed);\n      border-color: var(--accent-color-pressed);\n\n      /*& .main-button__icon-wrapper {\n        & svg path {\n          fill: var(--accent-color-pressed);\n        }\n      }*/\n\n    }\n\n    & .main-button__icon-wrapper {\n      & svg path {\n        fill: var(--white-color);\n      }\n    }\n  }\n}\n\n@media only screen and (min-device-width: 320px) {\n  .main-button {\n    min-width: 164px;\n    padding: 12px 20px;\n    font-size: 14px;\n    letter-spacing: 0.7px;\n  }\n  .main-button.secondary {\n    padding: 9px 31.5px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .main-button {\n    min-width: 220px;\n    padding: 12px 24px;\n    font-size: 18px;\n    letter-spacing: 0.9px;\n  }\n  .main-button.secondary {\n    padding: 9px 33px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .main-button {\n    min-width: 220px;\n    padding: 16px 36px;\n    font-size: 18px;\n    letter-spacing: 0.9px;\n  }\n  .main-button.secondary {\n    padding: 9px 33px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .main-button {\n    min-width: 220px;\n    padding: 20px 44px;\n    font-size: 20px;\n    letter-spacing: 1px;\n  }\n  .main-button.secondary {\n    padding: 9px 31.5px;\n  }\n}\n\n.main-button__icon-wrapper {\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  font-family: Inter, serif;\n  font-weight: 800;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
